const cssIsLoaded = () => {
  const stylesheets = Array.from(
    document.querySelectorAll('link[rel="stylesheet"]')
  )
  const promises = stylesheets.map(stylesheet => {
    return new Promise(resolve => {
      stylesheet.addEventListener('load', () => {
        resolve()
      })
    })
  })
  return Promise.all(promises)
}

export default container => {
  const sliderContainer = container.querySelector(
    '[data-before-after-container]'
  )
  const image = container.querySelector('[data-before-after-image]')
  const slider = container.querySelector('[data-before-after-slider]')
  const mainImage = container.querySelector(
    '[data-before-after-image-container]'
  )
  const rangeInput = container.querySelector('[data-before-after-input]')
  const planButtons = container.querySelectorAll('[data-before-after-buttons]')
  const line = container.querySelector('[data-before-after-line]')

  const init = () => {
    const setWidth = () => {
      image.style.width = `${slider.clientWidth}px`
    }

    setWidth()
    mainImage.style.width = `${rangeInput.value}%`

    planButtons.forEach(btn => {
      btn.addEventListener('click', evt => {
        if (evt.target.classList.contains('last')) {
          mainImage.style.width = '100%'
          line.style.left = '100%'
        }

        if (evt.target.classList.contains('first')) {
          mainImage.style.width = '0%'
          line.style.left = '0%'
        }
      })
    })

    slider.addEventListener('input', () => {
      mainImage.style.width = `${rangeInput.value}%`
      line.style.left = `${rangeInput.value}%`
    })

    slider.addEventListener('change', () => {
      mainImage.style.width = `${rangeInput.value}%`
      line.style.left = `${rangeInput.value}%`
    })

    window.addEventListener('resize', () => {
      setWidth()
    })

    cssIsLoaded().then(() => {
      setWidth()
    })

    window.addEventListener('load', () => {
      setWidth()
    })
  }

  if (sliderContainer) {
    init()
  }
}
